module.exports = __webpack_public_path__ + "img/emitEmotioneditor03.f8aae6c4.png";